import { Component } from '@angular/core';
import { take } from 'rxjs/operators';

import { AuthService } from './auth';
import { LanguageService } from 'src/app/services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(languageService: LanguageService, authService: AuthService) {
    authService.tryToLogin();

    authService.hasValidToken.pipe(take(1)).subscribe((_) => languageService.initialize());
  }
}
